import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { AuthenticationService } from 'app/auth/service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  /**
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   */
  constructor(private _router: Router, private _authenticationService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        const isLoginRequest = request.url.indexOf('/Auth/login') !== -1;
        const isApiRequest = request.url.startsWith(environment.apiUrl);
        if (isApiRequest && [401, 403].indexOf(err.status) !== -1) {
          if (!isLoginRequest) {
            if (err.status === 401) {
              this._authenticationService.logout();
              this._router.navigate(['/pages/authentication/login-v2']);
            } else {
              this._router.navigate(['/pages/miscellaneous/not-authorized']);
            }
          }

          // ? Can also logout and reload if needed
          // this._authenticationService.logout();
          // location.reload(true);
        }
        // throwError
        const error = err.error.message || err.statusText;
        return throwError(error);
      })
    );
  }
}
